import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { ActiveTabsIds } from "./tabs/types";

interface TabBarProps {
  tabs: {
    id: ActiveTabsIds;
    label: string;
  }[];
  active: ActiveTabsIds;
  onChange: (value: ActiveTabsIds) => void;
  trailing?: ReactNode;
}

export function TabBar({ tabs, active, onChange, trailing }: TabBarProps) {
  return (
    <div
      className="flex h-11 items-center gap-1 rounded-lg bg-(--color-surface-chip-inactive) px-1"
      role="tablist"
    >
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <Button
            key={tab.id}
            role="tab"
            aria-selected={isActive}
            tabIndex={isActive ? 0 : -1}
            onClick={() => onChange(tab.id)}
            variant="ghost"
            className={`h-auto px-4 py-1.5 text-sm font-medium ${
              isActive
                ? "bg-(--color-action) text-(--color-action-fg) shadow-sm hover:bg-(--color-action)/90"
                : "text-(--color-text-secondary) hover:bg-transparent hover:text-(--color-text-primary)"
            }`}
          >
            {tab.label}
          </Button>
        );
      })}
      {trailing && <div className="ml-auto flex items-center">{trailing}</div>}
    </div>
  );
}
